// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:720px){.content[data-v-5bf2c844]{flex-direction:column}}", ""]);
// Exports
module.exports = exports;
